import React, { useContext, useEffect, useState } from 'react';
import {Page_settings} from '../../../config/page_settings'
import { Modal, ModalBody } from 'reactstrap';
import strings from '../../../lang/strings';
import { observer } from 'mobx-react';
import ConfirmButton from '../button/confirm_button'
import {rootStore} from '../../../mobx/store'
import { customDateTimeFormat, string, formatNumber } from '../../../helper/common'

const AlarmModal = observer((props) => {
  const { show, toggle, alarm_id, is_alarm_page } = props; // context는 API 호출에 사용
  const [alarm, setAlarm] = useState(null); // 알람 상세 데이터
  const [loading, setLoading] = useState(true); // 로딩 상태
  const context = useContext(Page_settings)
  // 알람 상세 정보를 가져오는 함수
  const getDetail = () => {
    if (!alarm_id) return;

    setLoading(true);
    context.readAlarm(alarm_id, (status, res)=> {
      if (status) {
        setAlarm(res);
        setLoading(false);
      } else {
        context.showAlert(res.msg);
        setLoading(false);
      }
    });
  };

  const go_alarm_list = () => {
    toggle();
    if (!rootStore.isSignedIn) {
      props.history.push('/alarm_list')
      return
    }
  }

  useEffect(() => {
    if (show) {
      getDetail(); // 모달이 열릴 때 데이터 로드
    }
  }, [show, alarm_id]);

  return (
    <Modal isOpen={show} toggle={() => toggle()} className="modal-alarm">
      <ModalBody>
        {loading ? (
          // 로딩 상태일 때 표시
          <div className="text-center fs-16 sm-fs-14 f-m">{strings.loading}</div>
        ) : (
          <>
            <div className='modal-header-custom d-center position-relative'>
              <div className='fs-20 sm-fs-18 f-b'>{strings.alarm}</div>
              <div className='modal-close-btn d-center position-absolute' onClick={() => toggle()}>
                <img src={'/assets/image/close.png'} alt='' className='modal-close'/>
              </div>
            </div>
            <div className='alarm-container'>
            <div className="alarm-title-container">
              <div className="alarm-title fs-20 sm-fs-14 f-b">{alarm?.title}</div>
              <div className="alarm-created fs-14 sm-fs-12 f-m">{customDateTimeFormat(alarm.created_at)}</div>
            </div>

            {/* 알람 내용 */}
            <div className="alarm-content fs-16 sm-fs-14 space-break">{alarm?.content}</div>
            </div>
            {
              alarm.unread_count > 0 && is_alarm_page != true ? (
                <div className="">
                  <div className='fs-14 sm-fs-12 f-b alarm-unread'>{string.Format(strings.alarm_unread_guide, formatNumber(alarm.unread_count))}</div>
                  <ConfirmButton
                    enabled={true}
                    className={'bd-0 btn-confirm fs-15 sm-fs-14 mt-8 f-m d-center'}
                    onClick={go_alarm_list}
                    text={strings.alarm_go_list}
                  />
                </div>
              ) : null // 아무것도 렌더링하지 않을 때 null 반환
            }
          </>
        )}
      </ModalBody>
    </Modal>
  );
});

export default AlarmModal;
